export const maskingPhoneNumber = (phone?: string) => {
  if (!phone) return '';
  return `${phone.slice(0, 3)}${'*'.repeat(4)}${phone.slice(-2)}`;
};
